module.exports = __webpack_public_path__ + "img/idcard-icon.4331be55.svg";